import React from 'react';
import './App.css';
import { HashRouter, Route, Routes } from "react-router-dom";
import StartScreen from "./component/auth/start/StartScreen";
import 'bootstrap/dist/css/bootstrap.min.css';
import AddDevice from "./component/devices/addNewDevice/AddDevice";
import Layout from './component/layout/Layout';
import Login from './component/auth/login/Login';
import Registration from './component/auth/registration/Registration';
import ForgotRequest from './component/auth/forgot/ForgotRequest';
import ForgotRestore from './component/auth/forgot/ForgotRestore';
import AllDevices from './component/devices/allDevices/AllDevices';
import MainProfile from './component/profile/mainProfile/MainProfile';
import WaitingPage from './component/utils/WaitingPage';

function App() {
  return (
    <HashRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<StartScreen />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/forgot" element={<ForgotRequest />} />
          <Route path="/restore" element={<ForgotRestore />} />
          <Route path="/devices" element={<AllDevices />} />
          <Route path="/profile" element={<MainProfile />} />
          <Route path="/add-device" element={<AddDevice />} />
          <Route path="/waiting" element={<WaitingPage />} />
        </Routes>
      </Layout>
    </HashRouter>
  );
}

export default App;
